export default "__VITE_ASSET__DsVPOa4V__"